/* global $ */

class BackToTop {
  constructor() {
    this.$window = $(window);
    this.$body = $('body');
    this.backToTopButton = $('.back-to-top__link');

    this.init();
  }

  init() {
    this.backToTopButton.on('click.$body', this.onClick.bind(this));
  }

  deinit() {
    this.backToTopButton.off('click.$body');
  }

  onClick(e) {
    e.preventDefault();
    $('html,body').animate({ scrollTop: 0 }, 'slow');
  }
}

export default BackToTop;
